export { default as News } from './news'
export { default as Jobs } from './jobs'
export { default as Portfolio } from './portfolio'
export { default as Stories } from './stories'
